<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <DoctorQueueTable
      permission-key="antenatal_patients"
      endpoint="/antenatalpatients"
      action-path="/antenataltreatment"
      action-label="Treatment"
      no-permission-text="You have no permission to View Antenatal Patients"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DoctorQueueTable from "@/components/DoctorQueueTable.vue";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Antenatal Patients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DoctorQueueTable },
  data() {
    return {
      title: "Antenatal Patients",
      items: [{ text: "Dashboard", to: "/" }, { text: "Antenatal Patients", active: true }],
    };
  },
};
</script>
